/** Vilka filter som bestämmer vilka fordon listan får visa. */
export interface FleetListScope {
  organizationId: string;
  search: string;
  status: string;
  connected: string;
  preset: string;
  usageStatusId: string;
  carInfoFilterIds: number[] | null;
}

/**
 * Nyckel för den lista som hör ihop med synliga filter.
 * Sidbyte, sortering och kolumnfilter ingår inte: de byter inte kund.
 */
export function fleetListScopeKey(scope: FleetListScope): string {
  const carInfo =
    scope.carInfoFilterIds == null
      ? ''
      : [...scope.carInfoFilterIds].sort((a, b) => a - b).join(',');
  return [
    scope.organizationId,
    scope.search,
    scope.status,
    scope.connected,
    scope.preset,
    scope.usageStatusId,
    carInfo,
  ].join('\u001f');
}

/** Rader från ett tidigare filter får inte ritas under det filter som gäller nu. */
export function fleetRowsMatchScope(loadedScope: string | null, currentScope: string): boolean {
  return loadedScope !== null && loadedScope === currentScope;
}
